<div class="container-fluid webView padd">
    <!-- Header -->
    
    <div class="col-md-12 bgWhite padHeder"  style="padding: 10px 0px 0px 0px;">
        <div class="col-md-8" style="padding: 0px; display: inline-block;">
            <h5 style="display: inline-block;">Sub-Categories ({{categoryName}})</h5>

            
        </div>
        <div class="col-md-4" style="padding: 0px;display: inline-block; vertical-align: middle;"> 
            <span style="padding: 0px;">
                <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeSubModal()" ></i>                       
            </span>
            <span style="float: right;">
                
            </span>
            <span class="label" (click)="open(subcategory,0)" title="Add New Sub-Category"
                style="border-radius: 3px; padding: 5px 9px !important; font-size: 11px; background:#e88421 !important; color:#fff !important; float: right; margin-right: 5px;">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 17px; vertical-align: sub;"></i>
            </span>
        </div>
    </div>

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-md-12" style="padding: 0px;">
            <div class="col-md-12 mainCardHeader" style="display: inline-block;padding: 10px 0px 15px 0px;">       
                <div *ngIf="subCat.length != 0" id="divScrID" class="col-md-12" style="height: 350px;overflow-y:auto;">
                            <div *ngFor="let s of subCat let i = index"  style="margin-bottom: 5px;" class="col-12 col-sm-12 orangeBadge-wb"> 
                                <div class="row">                                     
                                    <div class="col-md-8" style="padding: 0px 0px 0px 15px;">
                                        <span style="font-size: 13px;">{{s.snm}}</span>                        
                                    </div>        
                                    <div class="col-md-4 font12" style="text-align: right;">
                                        <div class="lableBtnOrange" style="margin-right: 10px; display: inline-block; cursor: pointer" title="Edit" (click)="open(subcategory,s.sid)">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </div> 
                                        <div class="lableBtnOrange" style="display: inline-block; cursor: pointer;" title="Delete" (click)="deleteSubCat(i)">
                                            <i class="fa fa-trash"></i>
                                        </div>                                   
                                    </div>
                                </div>
                            </div>
                    </div>
                        <div class="bgWhite" *ngIf="subCat.length == 0" style="padding-left: 15px;">
                            <div class="nrf brdrRadius3" style="cursor: pointer;" (click)="open(subcategory,0)">
                                Click here to add a sub-category.
                            </div>
                        </div>
                        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 10px 0px 0px 15px; display: none;">
                            <span class="btn-add brdrRadius3" style="padding: 2px 10px 2px; cursor: pointer;" title="Add Sub-category" (click)="open(subcategory,0)">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i>
                                <span>Add</span>
                            </span>            
                        </div>
                        <!-- <div class="col-md-12" style="margin: 15px 0px 0px;">
                            <span class="label" (click)="open(subcategory,0)"
                                style="border-radius: 50%; top: 5px; cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                                <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                            </span>
                        </div> -->
            </div>

        </div>
    </div>

</div>

<div class="container-fluid mobView padd">
    <!--Header-->
    <div class="col-12 col-md-12 bgWhite padHeder mobView" style="padding: 10px 0px 0px 0px;">
        <div class="col-5 col-md-5 pad0" style="display: inline-block;vertical-align: sub;">
        <h4 style="display: inline-block;">{{categoryName}}</h4>
        </div>
        <div class="col-7 col-md-7 pad0" style="display: inline-block;vertical-align: middle;">
        <span style="float: right;">
            <span style="padding: 0px;">
                <i class="closeMdl zmdi zmdi-close brdrRadius3" style="float: right; top: -2px;" (click)="closeSubModal()" ></i>                       
            </span>
            <span class="label brdrRadius3" (click)="open(subcategory,0)"
                  style="margin-right: 10px; position: relative; top: 5px; cursor: pointer; bottom: 5px; padding: 10px; font-size: 11px; background:#e88421 !important; color:#fff !important">
                <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
            </span>
            
        </span>
    </div>
    </div>

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-12 col-sm-12" style="padding: 0px 15px 0px 15px;">
            <!-- Sub-Categories -->
            <div class="col-12 col-sm-12 mainCardHeader" style="display: inline-block;padding: 0px;">       
                <div id="divScrID" class="col-12 col-sm-12 TabView pad0">
                    <div *ngFor="let s of subCat let i = index"  style="margin-bottom: 10px;" class="col-12 col-sm-12 orngBadgeM"> 
                        <div class="row">                                     
                            <div class="col-8 col-sm-8 font13" style="padding: 0px 0px 0px 15px;">
                                <span>{{s.snm}}</span>                        
                            </div>        
                            <div class="col-4 col-sm-4 font13" style="text-align: right;">
                                <div style="margin-right: 20px;display: inline-block;" title="Edit" (click)="open(subcategory,s.sid)">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </div> 
                                <div style="display: inline-block;" title="Delete" (click)="deleteSubCat(i)">
                                    <i class="fa fa-trash"></i>
                                </div>                                   
                            </div>
                            <!-- <div class="col-8 col-sm-8" style="display: inline-block;padding: 3px 0px 5px 15px;color: #777;">
                                <span>{{s.items.length}} {{s.items.length == 1 || s.items.length == 0 ? 'item' : 'items'}}</span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="bgWhite font13" style="padding: 15px 0px 15px 0px;" *ngIf="subCat.length == 0">
                    <div class="nrf brdrRadius3" (click)="open(subcategory,0)">
                        Click here to add a sub-category.
                    </div>
                </div>
                <!-- <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 0px;">
                    <span class="btn-add" style="padding: 2px 10px 2px; cursor: pointer;" title="Add Sub-category" (click)="open(subcategory,0)">
                        <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i>
                        <span>Add</span>
                    </span>            
                </div> -->
            </div>
            
        </div>
    </div>
</div>

<!--Add Sub-Category-->
<ng-template #subcategory let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title"><span id="ApntmntHdr">{{isEditSubCategory == false ? 'Add Sub-Category' : 'Edit Sub-Category'}}</span></h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()" ></i>                       
                </div>
            </div>              
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12" style="padding: 0px 15px 15px 15px;">
            <div class="col-md-12 col-xs-12 col-12" style="padding: 0px 15px 0px 0px;display: inline-block;">
                <input type="text" [(ngModel)]="tempData.categoryName" class="form-control formCtlFltr" maxlength="50" style="text-indent: 2px;font-size: 13px;" placeholder="Enter Sub-Category">
            </div>
        </div>
        
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 0px 0px 15px 15px;">
            <span class="btn-green brdrRadius3" style="padding: 2px 10px; line-height: 25px; font-size: 14px;" (click)="isEditSubCategory == false ? saveNewSubCat() : editSubCat()" >
                <i class="fa fa-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>            
        </div>
    </div>
</ng-template>